import Axios from "axios";
import { useDispatch } from "react-redux";
import { APP_COOKIE_NAME, LOGOUT, SHOW_NOTIFICATION } from "../constants";
import { deleteCookie, getCookie, setCookie } from "../utils";

export const BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://tipsupport-api.deploy.ecoquimic.com"
    : "http://localhost:3005";

export const axios = Axios.create({ baseURL: BASE_URL });

const setAccessToken = async (token) => {
  axios.defaults.headers.common = {
    Authorization: `Bearer ${token || getCookie(APP_COOKIE_NAME)}`,
  };
  setCookie(APP_COOKIE_NAME, token, 1);
};

const chcekAccessToken = async (request) => {
  if (request.headers["Authorization"]) {
    return request;
  } else {
    const token = await getCookie(APP_COOKIE_NAME);
    if (token) {
      setAccessToken(token);
      return { ...request, headers: { Authorization: `Bearer ${token}` } };
    } else {
      return request;
    }
  }
};

const ConnectionHandler = () => {
  const dispatch = useDispatch();

  const showNotification = (message = "HA OCURRIDO UN ERROR") => {
    dispatch({
      type: SHOW_NOTIFICATION,
      payload: { show: true, status: "error", message },
    });
  };

  const exitFromApp = () => {
    deleteCookie(APP_COOKIE_NAME);
    dispatch({ type: LOGOUT });
  };

  axios.interceptors.request.use(
    async (request) => {
      const config = await chcekAccessToken(request);
      return config;
    },
    (err) => {
      try {
        showNotification(err.response.message);
      } catch (error) {

      }
    }
  );

  axios.interceptors.response.use(
    (config) => {
      if (
        config.config.url === `/user/login` ||
        config.config.url === `/user/check2FA`
      ) {
        setAccessToken(config.data.access_token);
      }
      return config;
    },
    (err) => {
      // Sin respuesta (red caída) no hay response: se trata como código 0.
      const { status = 0, data } = err.response || {};
      const { message = "" } = data || {};
      const { url = "", silent = false } = err.config || {};
      console.log("⛔️ RESPONSE ERROR (Target) => ", url);
      console.log("⛔️ RESPONSE ERROR (Message) => ", message);
      console.log("⛔️ RESPONSE ERROR (Code) => ", status);
      console.log("➕➖➖➖➖➖➖➖➖➖➖➖➖➖➖➖➖➖➖➖➖➕");
      if (status === 401) {
        if (!silent && message !== "Invalid token") showNotification(`${message}`);
        exitFromApp();
      } else if (status !== 300 && !silent) {
        // silent: la pantalla enseña el error a su manera (estado vacío, mensaje en el formulario...).
        showNotification(`${message}`);
      }
      // Se rechaza con el código HTTP: si no, las acciones seguirían por el camino de éxito con un número.
      return Promise.reject(status);
    }
  );

  return null;
};

export default ConnectionHandler;
